// extracted by mini-css-extract-plugin
module.exports = {"table":"Elements-module__table___MNz1H"};